import { Injectable } from '@angular/core';
import { ActiveFilters } from '@grid/abstractions';
import { QueryFilterState } from '@shared/models/query-filter-state';
import { FilterMap } from '@shared/modules/prime-grid-filters/helpers/types/filter-map.type';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ColumnFilterOperatorService {
  clearAll: Subject<void> = new Subject();
  run: Subject<void> = new Subject();
  checkStatus: Subject<void> = new Subject();

  private activeFilter: QueryFilterState = new QueryFilterState();

  get filters(): ActiveFilters {
    return this.activeFilter as ActiveFilters;
  }

  updateActiveFilters(filterMap: FilterMap): void {
    this.activeFilter.update(filterMap);
  }
}
